import proceso_model from './proceso_model';
import resource_model from '@/views/resource/models/resource_model';
import costo_model from '@/shared/models/costo.model';

export default {
  CodigoProceso: null,
  CodigoRecurso: null,
  CodigoCosto: null,
  Velocidad: null,
  TiempoAjuste: 0,
  MermaFija: null,
  CodigoUnidadMedida: null,
  UnidadMedida: null,
  MermaPorcentaje: 0,
  Proceso: JSON.parse(JSON.stringify(proceso_model)),
  Recurso: JSON.parse(JSON.stringify(resource_model)),
  Costo: JSON.parse(JSON.stringify(costo_model)),
  Realimentacion: null,
  TiempoRecarga: null,
  UsaDesarrollo: false,
};
